// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useSubmitting } from '@tectonics/prs/submitting';

import { TextField } from '../../../../atoms';
import { useCurrentPaymentTypeOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

type Props = {
  rootStyle?: {},
};

export function FieldMexicanStreetComplement({ rootStyle }: Props): Node {
  const inputId = useUniqueId();
  const [value, handleChange] = useUserInputAsTextField('mexicanStreetComplement');
  const submitting = useSubmitting();

  const isOptionalFieldByStreetNumber = useCurrentPaymentTypeOptionalFields('street_number');
  const isOptionalFieldByAddress = useCurrentPaymentTypeOptionalFields('address');

  if (isOptionalFieldByAddress || isOptionalFieldByStreetNumber) {
    return null;
  }

  return (
    <div style={rootStyle} data-test-name="address-street-complement">
      <label htmlFor={inputId}>Información Adicional</label>

      <TextField
        id={inputId}
        value={value}
        onChange={handleChange}
        placeholder="Opcional"
        readOnly={submitting}
        name="address-street-complement"
      />

    </div>
  );
}
